import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useField } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';

import FormCollege from '../../_organisms/FormCollege/index';
import Checkbox from '@atoms/Checkbox';
import { FormSubheader, ButtonDashed, ButtonNoStyles, DividerLightGreyStyled } from '@styled';
import colors from '@general/colors';

export const editProfileEducationValidationSchema = {
    firstCollege: Yup.string(),
    firstGraduationYear: Yup.string(),
    // secondCollegeCountry: Yup.string(),
    // secondCollegeState: Yup.string(),
    // secondCollege: Yup.string(),
    // secondGraduationYear: Yup.string(),
};

const EditProfileFieldsEducation = () => {
    const [isAddingAnother, setIsAddingAnother] = useState(false);
    const [firstNameField, firstNameFieldMeta, firstNameFieldHelpers] = useField('firstCollegeName');
    const [firstCodeField, firstCodeFieldMeta, firstCodeFieldHelpers] = useField('firstCollegeCode');
    const [firstYearField, firstYearFieldMeta, firstYearFieldHelpers] = useField('firstGraduationYear');
    const [secondNameField, secondNameFieldMeta, secondNameFieldHelpers] = useField('secondCollegeName');
    const [secondCodeField, secondCodeFieldMeta, secondCodeFieldHelpers] = useField('secondCollegeCode');
    const [secondYearField, secondYearFieldMeta, secondYearFieldHelpers] = useField('secondGraduationYear');
    const [noCollegeField] = useField('noCollege');

    const resetFirstCollege = () => {
        firstNameFieldHelpers.setValue('');
        firstCodeFieldHelpers.setValue('');
        firstYearFieldHelpers.setValue('');
    };

    const resetSecondCollege = () => {
        secondNameFieldHelpers.setValue('');
        secondCodeFieldHelpers.setValue('');
        secondYearFieldHelpers.setValue('');
    };

    const togglenoCollege = () => {
        resetFirstCollege();
        resetSecondCollege();
    };

    //
    useEffect(() => {
        if (noCollegeField.value) {
            togglenoCollege(noCollegeField.value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [noCollegeField.value]);

    const handleRemove = () => {
        setIsAddingAnother(false);
        resetSecondCollege();
    };

    return (
        <>
            {!noCollegeField.value && (
                <>
                    <FormSubheader>Add a College</FormSubheader>
                    <FormCollege
                        nameCollegeName="firstCollegeName"
                        nameCollegeCode="firstCollegeCode"
                        yearFieldName="firstGraduationYear"
                    />
                    {!isAddingAnother && !secondCodeField.value && (
                        <ButtonDashed
                            style={{ fontSize: '16px', padding: '15px', color: '#1A1A1A' }}
                            className="btn-block mt-3"
                            onClick={() => setIsAddingAnother(true)}
                        >
                            <FontAwesomeIcon
                                style={{ marginRight: '10px' }}
                                icon={faPlusCircle}
                                color={colors.darkGray}
                                size="lg"
                            />{' '}
                            Add Another College
                        </ButtonDashed>
                    )}
                    {(isAddingAnother || secondCodeField.value) && (
                        <>
                            <DividerLightGreyStyled className="mt-4" />
                            <FormSubheader className="mt-3 d-flex justify-content-between">
                                Add a College
                                <ButtonNoStyles
                                    onClick={handleRemove}
                                    style={{ fontWeight: 'bold', fontSize: '13px' }}
                                    type="button"
                                >
                                    Remove
                                </ButtonNoStyles>
                            </FormSubheader>
                            <FormCollege
                                nameCollegeName="secondCollegeName"
                                nameCollegeCode="secondCollegeCode"
                                yearFieldName="secondGraduationYear"
                            />
                        </>
                    )}
                </>
            )}
            <div className="mt-4">
                <Checkbox name="noCollege" label="I didn't attend college" />
            </div>
        </>
    );
};

export default EditProfileFieldsEducation;
